module.exports = __webpack_public_path__ + "assets/img/00017.571e80cd.png";